import { useCallback, useMemo } from "react";

import { useRegistriesQuery } from "@/app/types/generated/graphql";
import { AggregatedRegistryCode } from "@/app/types/okta.types";

export const useActiveRegistryDisplayName = (registryCode?: AggregatedRegistryCode) => {
  const { data, loading: registriesQueryLoading } = useRegistriesQuery({
    fetchPolicy: "cache-first",
  });

  const getRegistryDisplayName = useCallback(
    (registryCode?: AggregatedRegistryCode) => {
      if (!registryCode || !data?.registries?.length) return "";
      return data?.registries?.find((registry) => registry.code === registryCode)?.shortName ?? "";
    },
    [data?.registries],
  );

  const activeRegistryDisplayName = useMemo(() => {
    return getRegistryDisplayName(registryCode);
  }, [registryCode, getRegistryDisplayName]);

  return {
    getRegistryDisplayName,
    activeRegistryDisplayName,
    registriesQueryLoading,
  };
};
